export enum AuthQueryKeys {
  RequestPasswordReset = 'REQUEST_PASSWORD_RESET',
}
